import actions from './actions.js'
import mutations from './mutations.js'
import getters from './getters.js'

const state = {
  user_full_name: localStorage.getItem("user_full_name"),
  user_language: localStorage.getItem("user_language"),
  user_entity_types: JSON.parse(localStorage.getItem("user_entity_types")),
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}